import {Dispatcher} from 'flux';

const assign = require('object-assign');

const AppDispatcher = assign(new Dispatcher(), {

    handleServerAction(action) {
        var payload = {
            source: 'SERVER_ACTION',
            action: action
        };
        this.dispatch(payload);
    }
})

export default AppDispatcher;
